import React from 'react';
import { pick } from 'ramda';
import { Loader } from 'js/components/common/Loader';
import { ManagedPopup } from 'js/components/common/Popup';
import { useResizeLayout } from 'js/components/common/PopupManager/hooks';

import * as hooks from '@core/js/components/popups/AdvancedPlayerMessage/hooks';

import style from './AdvancedPlayerMessage.scss';

const popupClassNames = pick(['actionButtons', 'header'], style);

export const AdvancedPlayerMessage = ({ data, refs, isActive, ...props }) => {
    useResizeLayout(refs);

    const { message, imageUrl } = data.action;
    const imageInfo = hooks.useLoadImage(data);
    const { buttons, onClose } = hooks.useGetButtons(data);
    const { className, inlineStyle } = hooks.useStyleAttributes({ imageInfo, imageUrl });

    if (isActive && imageUrl && !imageInfo) {
        return <Loader className={style.loader} />;
    }

    return (
        <ManagedPopup
            {...props}
            className={`advanced-player-message__Popup ${className}`}
            classNames={popupClassNames}
            onClose={onClose}
            style={inlineStyle}
            buttons={buttons}
        >
            <div
                className={style.htmlContainer}
                dangerouslySetInnerHTML={{ __html: message }}
            />
        </ManagedPopup>
    );
};
